import { render } from "./SimpleDatePiker.vue?vue&type=template&id=70383635&lang=pug"
import script from "./SimpleDatePiker.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleDatePiker.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__